import React, { Component } from 'react';
import PropTypes from 'prop-types';

import EditBox from './EditBox';

export class EditColumn extends Component {
  static propTypes = {
    products: PropTypes.object.isRequired,
    personas: PropTypes.object.isRequired,
    milestones: PropTypes.object.isRequired,
    milestoneConnectors: PropTypes.object.isRequired,
  };

  getConnectors(stageName) {
    let connectors = [];
    switch (stageName) {
      case 'trigger':
        if (Object.keys(this.props.milestoneConnectors.trigger).length > 0) {
          connectors = this.props.milestoneConnectors.trigger;
        }
        break;
      case 'guide':
        if (Object.keys(this.props.milestoneConnectors.guide).length > 0) {
          connectors = this.props.milestoneConnectors.guide;
        }
        break;
      case 'key':
        if (Object.keys(this.props.milestoneConnectors.keyVar).length > 0) {
          connectors = this.props.milestoneConnectors.keyVar;
        }
        break;
      case 'crisis':
        if (Object.keys(this.props.milestoneConnectors.crisis).length > 0) {
          connectors = this.props.milestoneConnectors.crisis;
        }
        break;
      default:
        break;
    }

    if (connectors.length > 0) {
      const { connectorIds } = this.props.milestones[stageName];
      const sortedConnectors = connectorIds.map((cId) => {
        return connectors[cId];
      });
      return sortedConnectors;
    } else {
      return connectors;
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.props.milestones
          ? Object.values(this.props.milestones).map((milestone) => {
              const connectors = this.getConnectors(milestone.title);

              let connect = Object.keys(connectors).map((id) => {
                return connectors[id];
              });

              let elementArr = [milestone].concat(connect);

              return elementArr.map((el, i) => {
                el.products = el.productIds.map((productId) => {
                  return this.props.products[productId];
                });
                el.personas = el.personaIds.map((personaId) => {
                  return this.props.personas[personaId];
                });

                return (
                  <EditBox
                    key={`${el.title}-${el.id}`}
                    id={el.id}
                    title={el.title}
                    color={el.color}
                    products={el.products}
                    personas={el.personas}
                    connector={el.connectorName}
                  >
                    {el.content}
                  </EditBox>
                );
              });
            })
          : null}
      </React.Fragment>
    );
  }
}

export default EditColumn;
